import { apiGetRequest } from 'utilities/http/api/apiHttp';

export const apiContent = {
  getPupDocsContent: () => apiGetRequest<{ pupdocsContent: unknown }>('pupdocs/content'),
};
